import { useTheme } from '@mui/material/styles'
import useMediaQuery from "@mui/material/useMediaQuery";


export const useBreakpoint = () => {
    const theme = useTheme();

    const keys = [...theme.breakpoints.keys].reverse();
    return (
        keys.filter((key) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const matches = useMediaQuery(theme.breakpoints.up(key));
            return matches;
        }, null)[0] ?? "xs"
    );
}

export const isMobileDevice = (brkpt) =>
{
    return ['xs','sm','md','mobile','tablet'].includes(brkpt)
}